export default __webpack_public_path__ + "static/iconography-image-j-26baad8da531fae181cf1a45632c2bcb31c30060498a82c7f5b31f093368021e.png";